import {
  CLEAR_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMERS_PAGINATION,
} from '../constants/Customers';

const initialState = {
  customers: [],
  customer: {
    id: 0,
    name: '',
    emails: [],
    phones: [],
    addresses: [],
    cars: [],
    invoices: [],
    company: '',
  },
  loading: false,
  search: '',
  perPage: 10,
  from: 0,
  to: 0,
  page: 1,
};

const customers = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMERS:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
        loading: true,
      };
    case UPDATE_CUSTOMERS_PAGINATION:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
      };
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.customers,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case CLEAR_CUSTOMER:
      return {
        ...state,
        customer: initialState.customer,
      };
    case GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        customer: action.customer,
        loading: false,
      };
    case CREATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customer: action.customer,
        customers: [...state.customers, action.customer],
        loading: false,
      };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customer: action.customer,
        customers: state.customers
          ? state.customers.map((c) =>
              c.id === action.id ? action.customer : c
            )
          : [],
        loading: false,
      };
    default:
      return state;
  }
};

export default customers;
